import React from 'react'
import AccessTimeIcon from '@mui/icons-material/AccessTime'
import ClearIcon from '@mui/icons-material/Clear'
import ArrowOutwardIcon from '@mui/icons-material/ArrowOutward'

type Props = {
  hit: any
}

const RecentSearchItem: React.FC<Props> = ({ hit }) => {
  const handleClick = () => hit.onTapAhead(hit)

  return (
    <div className="aa-ItemWrapper">
      <div className="aa-ItemContent" onClick={handleClick}>
        <AccessTimeIcon sx={{ color: '#808080', fontSize: 20, margin: 1 }} />
        {hit.label}
      </div>
      <div className="aa-ItemActions">
        <div
          className="aa-ItemActionsButton"
          onClick={hit.onRemove}
          title={'Supprimer cette recherche'}
        >
          <ClearIcon sx={{ color: '#808080', fontSize: 18, margin: 1, cursor: 'pointer' }} />
        </div>
        <div className="aa-ItemActionsButton" onClick={handleClick} title={'Lancer la recherche'}>
          <ArrowOutwardIcon sx={{ color: '#808080', fontSize: 18, margin: 1, cursor: 'pointer' }} />
        </div>
      </div>
    </div>
  )
}
export default RecentSearchItem
